/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneInstagramArticlesList from 'sites/allas/components/standalone/InstagramArticlesList';

export const DynamicStandaloneInstagramArticlesList = StandaloneInstagramArticlesList;
export type DynamicStandaloneInstagramArticlesListProps = PropsFromComponent<typeof StandaloneInstagramArticlesList>;

export const DynamicStandaloneInstagramArticlesListWith = (extras: DynamicStandaloneExtras): typeof StandaloneInstagramArticlesList => {
    return function DynamicStandaloneInstagramArticlesList(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'InstagramArticlesList');
        return <StandaloneInstagramArticlesList {...mergeProps({ options: { theme } }, props)} />;
    }
}